import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Event Booking/Receipt Voucher Invoice.png"
import img2 from "../../assets/Images/Event Booking/Event-Booking.png"
import DocNavigation from "../../components/DocNavigation";

export default function EliminateManualRegisters() {
  return (
    <section className="space-y-16">

      {/* HERO */}
      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-4">
          Eliminate Manual Registers
        </h1>

        <p className="text-md text-slate-600 max-w-4xl">
          Traditional banquet and event operations rely heavily on handwritten
          registers, notebooks, and loose papers. These manual methods are slow,
          error-prone, and extremely difficult to audit. EventFlow completely
          eliminates manual registers by digitizing every operational and
          financial record.
        </p>

        <section className="border-l border-[#C9A24E] pl-4 mt-6">
          <h2 className="text-lg font-semibold mb-3">Overview</h2>
          <p className="text-slate-600 text-sm">
            With EventFlow, all bookings, estimates, receipts, expenses, and
            reports are stored securely in one centralized system. This removes
            dependency on paper records and ensures consistency across the
            organization.
          </p>
        </section>
      </section>

      {/* PROBLEMS */}
      <section className="bg-slate-100 rounded-xl p-4">
        <h3 className="font-semibold mb-4">Problems with Manual Registers</h3>
        <ul className="list-disc pl-5 text-slate-600 space-y-2">
          <li>Lost or damaged registers</li>
          <li>Illegible handwriting and incorrect totals</li>
          <li>No proper history or audit trail</li>
          <li>Time-consuming record searching</li>
          <li>Difficulty in generating reports</li>
        </ul>
      </section>

      {/* SOLUTION */}
      <section className="p-4">
        <div>
          <h3 className="font-semibold mb-3">How EventFlow Solves This</h3>
          <p className="text-slate-600 mb-3">
            EventFlow replaces every manual register with structured digital
            modules that automatically store and organize data.
          </p>
          <ul className="list-disc pl-5 text-slate-600 space-y-1">
            <li>Digital booking & estimate records</li>
            <li>Auto-generated receipts & invoices</li>
            <li>Searchable historical data</li>
            <li>Secure cloud-ready storage</li>
          </ul>
        </div>

        <div className=" rounded-lg p-4 mt-6 flex flex-col justify-center items-center gap-5">
          <img src={img2} alt="" className="w-1/2 h-auto shadow-lg" />
          <img src={img1} alt="" className="w-1/2 h-auto shadow-lg" />
        </div>
      </section>

      {/* VALUE */}
      <section className="bg-slate-100 rounded-xl p-4">
        <h3 className="font-semibold mb-3">Business Impact</h3>
        <p className="text-slate-600 max-w-4xl">
          Eliminating manual registers improves operational speed, increases
          accuracy, and builds trust with customers and auditors. Management
          gains full visibility into operations without relying on physical
          books.
        </p>
      </section>

      {/* <section className="border-t pt-8 mt-12">
        <p className="text-slate-600">
          Next, learn about{" "}
          <Link to="/docs/no-double-booking" className="font-medium text-[#C9A24E]">
            Prevent Double Bookings
          </Link>.
        </p>
      </section> */}
 <DocNavigation
        previous={{
          title: "Access Control Module",
          link: "/docs/access-control"
        }}
        next={{
          title: "Prevent Double Bookings",
          link: "/docs/no-double-booking"
        }}
      />
    </section>
  );
}
